export const models = {
  modelA: 'modelA',
  modelB: 'modelB',
};
